import { useAppSelector } from '@/redux/store';
import { hasPaidMembershipAccess } from '@/utils/membership-access';

const useCheckMembership = (): boolean => {
  const ServiceInfo = useAppSelector((state) => state.user.ServiceInfo);

  return hasPaidMembershipAccess(ServiceInfo);
};

export default useCheckMembership;
